import { render, staticRenderFns } from "./RectangleCoordinateEditor.vue?vue&type=template&id=0f9c75e8&scoped=true&"
import script from "./RectangleCoordinateEditor.vue?vue&type=script&lang=ts&"
export * from "./RectangleCoordinateEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c75e8",
  null
  
)

export default component.exports